import { useEffect } from "react";
import { useSelector } from "react-redux";

// Same Productlane workspace as supply_v2 (supply_v2/frontend/src/lib/providers/productlane-provider.tsx)
const WIDGET_KEY = "fb85f641-f6f1-43e2-8c39-0d287d1fb854";
const SCRIPT_SRC = "https://widget.productlane.com/latest.productlane-widget.min.js";

// Productlane must be initialized once per page load, while AdminLayout remounts on every login/logout.
let initialized = false;

// Snippet from https://productlane.com/docs/setup/widget: calls made before the script loads are queued.
function initProductlane(email) {
  const P = { queue: {} };
  ["set", "open", "close", "toggle", "on", "off", "init"].forEach((m) => {
    P[m] = (...args) => {
      P.queue[m] = { args };
    };
  });
  window.Productlane = P;

  P.init({
    widgetKey: WIDGET_KEY,
    user: { email },
    mode: "light",
    position: "right",
  });

  const script = document.createElement("script");
  script.src = SCRIPT_SRC;
  script.async = true;
  script.crossOrigin = "anonymous";
  document.body.appendChild(script);

  initialized = true;
}

const ProductlaneWidget = () => {
  const { auth } = useSelector((state) => state.auth.auth);
  const email = auth?.email;

  useEffect(() => {
    if (!email) return undefined;

    if (!initialized) {
      initProductlane(email);
    } else {
      window.Productlane.enable?.();
      window.Productlane.set({ user: { email } });
    }

    // Logout doesn't reload the page: forget the user and hide the widget until the next login.
    return () => {
      window.Productlane?.signOut?.();
      window.Productlane?.disable?.();
    };
  }, [email]);

  return null;
};

export default ProductlaneWidget;
